import React, { useState, useEffect } from "react"; // Règle les erreurs 'useState' et 'useEffect'
import { supabase } from "./services/supabaseClient";       // Règle l'erreur 'supabase'
import MainApp from "./MainApp";                   // Règle l'erreur 'MainApp'

function App() {
  const [session, setSession] = useState(null);
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Vérifier la session au démarrage
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // 2. Écouter les changements (login/logout)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) setSelectedCompetition(null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
        Chargement...
      </div>
    );
  }

  // On affiche MainApp dans tous les cas, c'est lui qui gère l'affichage interne
  return (
    <MainApp 
      session={session} 
      selectedCompetition={selectedCompetition} 
      onSelectCompetition={setSelectedCompetition}
      onBackToDashboard={() => setSelectedCompetition(null)}
    />
  );
}

// CRUCIAL : Règle l'erreur "export 'default' was not found"
export default App;